const SettingsEnums = Object.freeze({
  DefaultLocale: 'tr',
  MaxUploadSize: 62914560
});

module.exports = { SettingsEnums };
